import { X } from "lucide-react";

interface StepHeaderProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
}

export function StepHeader({ title, subtitle, onClose }: StepHeaderProps) {
  return (
    <div className="flex items-start justify-between px-8 py-6 border-b border-gray-100">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        {subtitle ? <p className="mt-1 text-gray-500">{subtitle}</p> : null}
      </div>
      <button
        type="button"
        onClick={onClose}
        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
        aria-label="Cerrar"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}


